import { Button, defaultIconSize } from '@synqo/frontend-component-library';
import { IconDownload, IconEye } from '@tabler/icons-react';
import styles from './InvoiceSnapshotRowActions.module.css';

export interface InvoiceSnapshotRowActionsProps {
    snapshotId: string;
    onPreview: (snapshotId: string) => void;
    onDownload: (snapshotId: string) => void;
    locked: boolean;
}

/**
 * Shows or downloads the invoice of one row, visible while the row is hovered. The clicks do not reach the row,
 * which would open the detail page.
 */
// @ai-generated 2026-09-29T07:37:25+00:00 by philipp.kammerer@synqony.com using Claude Opus 5.5 (1M context)
export function InvoiceSnapshotRowActions({
    snapshotId,
    onPreview,
    onDownload,
    locked,
}: InvoiceSnapshotRowActionsProps) {
    return (
        <span className={styles.actions}>
            <Button
                appearance="outlined"
                type="square"
                label="Rechnung ansehen"
                tooltip="Rechnung ansehen"
                locked={locked}
                onClick={(event) => {
                    event.stopPropagation();
                    onPreview(snapshotId);
                }}
            >
                <IconEye size={defaultIconSize} />
            </Button>
            <Button
                appearance="outlined"
                type="square"
                label="Rechnung herunterladen"
                tooltip="Rechnung herunterladen"
                locked={locked}
                onClick={(event) => {
                    event.stopPropagation();
                    onDownload(snapshotId);
                }}
            >
                <IconDownload size={defaultIconSize} />
            </Button>
        </span>
    );
}
